import axios from "axios";
import { useQuery } from "@tanstack/react-query";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;
export const api = axios.create({ baseURL: API });

export const useApi = (path, enabled = true) =>
  useQuery({ queryKey: [path], queryFn: () => api.get(path).then((r) => r.data), enabled, retry: 1 });

export const errorMessage = (e) => {
  const d = e?.response?.data?.detail;
  if (!d) return e?.message || "Something went wrong. Please try again.";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x?.msg || "").filter(Boolean).join(" ");
  return d.msg || "Something went wrong.";
};

export const mediaUrl = (u) => (u && u.startsWith("/api/") ? `${BACKEND_URL}${u}` : u);

export const inr = (n) =>
  new Intl.NumberFormat("en-IN", { style: "currency", currency: "INR", maximumFractionDigits: 0 }).format(n || 0);

export const cycleLabel = (c) => ({ monthly: "/month", yearly: "/year", "one-time": "one-time" }[c] || "");

export const gstNote = (s) =>
  s?.gst_mode === "inclusive" ? `Inclusive of ${s?.gst_rate ?? 18}% GST` : `+ ${s?.gst_rate ?? 18}% GST`;

export const waLink = (num, text = "") =>
  `https://wa.me/${String(num || "").replace(/\D/g, "")}${text ? `?text=${encodeURIComponent(text)}` : ""}`;
